import React from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { compose, lifecycle, withProps } from "recompose";
import { fetchApi } from "core/api/hoc";
import { candidate, insider } from "routes/paths";
import { authenticated } from "modules/user/auth/hoc";
import { fetchUserDataApi } from "../selectors";
import { fetchUserData } from "../api";

export default fn => Component =>
  compose(
    authenticated,
    connect(),
    fetchApi(fetchUserData, ({ match }) => ({
      payload: {
        backUrl: match.url
      },
      selector: fetchUserDataApi,
      sync: true,
      key: "userDataApi"
    })),
    withProps(props => ({
      isAllowed: !props.userDataApi.error && fn(props.userDataApi.data)
    })),
    lifecycle({
      componentDidMount() {
        const { data, error } = this.props.userDataApi;
        if (!this.props.isAllowed && !error) {
          if (data.user_type === "candidate" && !data.on_boarded) {
            return this.props.dispatch(push(candidate.onboarding));
          }
          if (data.user_type === "candidate") {
            return this.props.dispatch(push(candidate.main));
          }
          if (data.user_type === "insider" && data.on_boarded) {
            return this.props.dispatch(push(insider.insiderMain));
          }
          if (data.user_type === "insider" && !data.on_boarded) {
            return this.props.dispatch(push(insider.onboarding));
          }
        }
      }
    })
  )(
    ({ userDataApi, ...props }) =>
      !userDataApi.error && props.isAllowed && <Component {...props} />
  );



// WEBPACK FOOTER //
// ./src/modules/user/auth/hoc/authorized.js